import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ActivityService } from '../../services/activity.service';
import { AlertService } from '../../providers/alert.service'

@Component({
  selector: 'page-activity',
  templateUrl: 'activity.html',
  viewProviders:[
    ActivityService
  ]
})
export class ActivityPage {

  constructor(
    public navCtrl: NavController,
     public navParams: NavParams,
     public alert:AlertService,
     public activityService:ActivityService) {}

  ionViewDidLoad() {
  }

  //领取红包
  //chen 2017-03-06
  draw(){
    this.activityService.getConsumReturnCash().then(s=>{
      if(s.Result){
        this.alert.showAlert(s.Error);
      }else{
        this.alert.showAlert(s.Error);
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/activity/activity.ts